module.exports = __webpack_public_path__ + "static/img/step1-image.bbf57ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step1-image.png
// module id = WE8n
// module chunks = 1